import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Input, Space, Button, message, theme, Flex, Typography } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useDebouncedSearch } from '../../hooks';
const { useToken } = theme;
const { Text } = Typography;

const DidomiAccountMappingPage = (props) => {
  const [searchText, setSearchText] = useState('');
  const { token } = useToken();
  const debouncedChangeHandler = useDebouncedSearch(setSearchText, 350);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    message.success('API Key copied to clipboard!');
  };

  const accountOwnersList = props?.accountOwners?.toJS?.() || [];

  const columns = [
    {
      title: 'Sourcepoint Account Name',
      dataIndex: 'accountName',
      key: 'accountName',
      sorter: (a, b) => (a.accountName || '').localeCompare(b.accountName || ''),
      defaultSortOrder : 'ascend',
      render: (text) => text || '',
    },
    {
      title: 'Sourcepoint Account ID',
      dataIndex: 'accountId',
      key: 'accountId',
      sorter: (a, b) => (a.accountId || 0) - (b.accountId || 0),
      render: (text) => text ?? '',
    },
    {
      title: 'Didomi Organization ID',
      dataIndex: 'didomiOrganizationId',
      key: 'didomiOrganizationId',
      sorter: (a, b) => (a.didomiOrganizationId || '').localeCompare(b.didomiOrganizationId || ''),
      filters: [{ text: 'All', value: 2 }, { text: 'Mapped', value: 1 }, { text: 'Not Mapped', value: 0 }],
      filterMultiple: false,
      onFilter: (value, record) => {
        if (value === 2)  return true;
        if (value === 0) {
          return !record.didomiOrganizationId;
        }
        return !!record.didomiOrganizationId;
      },
      render: (text) => text || '',
    },
    {
      title: 'Didomi Public API Key',
      dataIndex: 'didomiPublicApiKey',
      key: 'didomiPublicApiKey',
      sorter: (a, b) => (a.didomiPublicApiKey || '').localeCompare(b.didomiPublicApiKey || ''),
      filters: [{ text: 'All', value: 2 }, { text: 'Mapped', value: 1 }, { text: 'Not Mapped', value: 0 }],
      filterMultiple: false,
      onFilter: (value, record) => {
        if (value === 2)  return true;
        if (value === 0) {
          return !record.didomiPublicApiKey;
        }
        return !!record.didomiPublicApiKey;
      },
      render: (text) => (
        <Space>
          <Text ellipsis className='api-key-display'>
            {text}
          </Text>
          {text && <Button icon={<CopyOutlined />} onClick={() => handleCopy(text)} type="link" />}
        </Space>
      ),
    },
  ];

  return (
    <>
      <div>
        <div style={{ marginTop: token.margin, marginBottom: token.margin, width: '100%' }}>
          <Flex justify='start' align='center'>
            <Input
              placeholder='Search'
              type='search'
              onChange={({ target: { value } }) => debouncedChangeHandler(value)}
              style={{ width: 360, height: 32 }}
            />
          </Flex>
        </div>
        <Table
          className='didomi-account-mapping-table'
          columns={columns}
          loading={props.pending}
          dataSource={accountOwnersList.filter(item => {
            const normalizedSearch = searchText.toLowerCase();
            return (
              (item.accountName || '').toLowerCase().includes(normalizedSearch) ||
              String(item.accountId || '').includes(normalizedSearch) ||
              (item.didomiOrganizationId || '').toLowerCase().includes(normalizedSearch) ||
              (item.didomiPublicApiKey || '').toLowerCase().includes(normalizedSearch)
            );
          })}
          rowKey='accountId'
          pagination={{ position: ['bottomCenter'], showSizeChanger: true, pageSizeOptions: ['10', '20', '50', '100'] }}
          scroll={{ x: 1024 }}
        />
      </div>
    </>
  );
};

const mapStateToProps = function (store) {
  return {
    pending: store.accountState.getIn(['accountOwners', 'pending']),
    accountOwners: store.accountState.getIn(['accountOwners', 'value']),
  };
};

DidomiAccountMappingPage.propTypes = {
  pending: PropTypes.bool,
  accountOwners: PropTypes.object,
};

export default connect(mapStateToProps)(DidomiAccountMappingPage);
